export default __webpack_public_path__ + "static/media/plus.49f23970.svg";